define('modules/editor/behaviours/draggable',['require','exports','module'],function(require, exports, module) {
  "use strict";
   
  var DraggableEvents = {
    "dragstart": "onDragstart",
    "dragend": "onDragend",
    "dragover": "onDragover",
    "drop": "onDrop"
  };

  module.exports = {
    onDragstart: function(e) {
      e.originalEvent.dataTransfer.setData("text", "section");
      e.originalEvent.dataTransfer.effectAllowed = "move";
      this.data.state.setDragPayload("section", "move", this.model);
    },
    onDragend: function(e) {
      this.data.state.clearDragPayload();
    },
    onDragover: function(e) {
      var payload = this.data.state.getDragPayload(),
          dataTransfer = e.originalEvent.dataTransfer;
      if (payload.type.match(/element/) || payload.type.match(/nestedElement/)) {
        e.preventDefault();
        e.stopPropagation();
        dataTransfer.dropEffect = payload.op;
      }
    },
    onDrop: function(e) {
      e.preventDefault();
      var payload = this.data.state.getDragPayload(),
          pos = this.calculateDropPosition(e.originalEvent);
      /*} else if(payload.type.match(/nestedElement/)){
        //just set position
        payload.model.setPosition(pos);
        this.data.state.clearDragPayload();
      }*/
      if (payload.type.match(/(section|area)/) && this.model.name.match(/area/)) {
        e.stopPropagation();
      } else if (payload.type.match(/element/)) {
        e.stopPropagation();
        if (payload.op === "copy"){
          this.data.addElementToSection(this.model, payload.type, pos);
        } else if (payload.op === "move"){
          this.data.moveElementToSection(this.model, payload.model, pos);
        }
        this.data.state.clearDragPayload();
      }
    },
    calculateDropPosition: function(ev) {
      var rect = _.clone(this.el.getBoundingClientRect()),
          offset = this.data.state.getDragOffset(),
          top,
          pos;
      top = rect.top + document.body.scrollTop;
      pos = { "x": parseInt((ev.clientX - rect.left) - offset.x),
              "y": parseInt((ev.clientY - rect.top) - offset.y) };
      pos.upperHalf = (pos.y) < (rect.height/2);
      if (pos.y > (top + rect.height) || pos.x > (rect.left + rect.width))
        return false;
      else
        return pos;
    },
    _getHeight: function(r, ref) {
      return (r.top - ref.top) + r.height;
    },
    _getWidth: function(r, ref) {
      return (r.left - ref.left) + r.width;
    },
    _adjustSize: function() {
      // make sure the element is big enough to contail all its content
      var children = this.el.children,
          rect = this.el.getBoundingClientRect(),
          box = {width: rect.width, height: rect.height},
          border = parseFloat(this.el.style.borderWidth) * 2;

      _.each(children, function(c) {
        var crect = c.getBoundingClientRect(),
            ch = this._getHeight(crect, rect),
            cw = this._getWidth(crect, rect);

        box.height = Math.max(box.height, ch);
        box.width = Math.max(box.width, cw);
      }, this);

      if (box.height < 10 || box.width < 10) { return; }
      if ((box.height - border) <= rect.height ||
          (box.width - border) <= rect.width) {
        return;
      }

      if (this.model.setSize) {
        this.model.setSize(box);
      }
      this.el.style.height = box.height + "px";
      this.el.style.width = box.width + "px";
    },
    mixed: function(klass, proto) {
			proto.events = _.extend(proto.events || {}, DraggableEvents);
    }
  };
});

